import {config, library} from '@fortawesome/fontawesome-svg-core';

// Brand Icons
import {faCcAmex} from '@fortawesome/free-brands-svg-icons/faCcAmex';
import {faCcMastercard} from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import {faCcVisa} from '@fortawesome/free-brands-svg-icons/faCcVisa';
import {faChrome} from '@fortawesome/free-brands-svg-icons/faChrome';
import {faFacebookF} from '@fortawesome/free-brands-svg-icons/faFacebookF';
import {faGoogle} from '@fortawesome/free-brands-svg-icons/faGoogle';
import {faInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram';
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter';

// Light Icons
import {faAlignLeft as falAlignLeft} from '@fortawesome/pro-light-svg-icons/faAlignLeft';
import {faArchive as falArchive} from '@fortawesome/pro-light-svg-icons/faArchive';
import {faArrowLeft as falArrowLeft} from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import {faArrowRight as falArrowRight} from '@fortawesome/pro-light-svg-icons/faArrowRight';
import {faArrowRightFromBracket as falArrowRightFromBracket} from '@fortawesome/pro-light-svg-icons/faArrowRightFromBracket';
import {faArrowsRotate as falArrowsRotate} from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import {faArrowsRotateReverse as falArrowsRotateReverse} from '@fortawesome/pro-light-svg-icons/faArrowsRotateReverse';
import {faArrowUpFromBracket as falArrowUpFromBracket} from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import {faBadgeCheck as falBadgeCheck} from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import {faBan as falBan} from '@fortawesome/pro-light-svg-icons/faBan';
import {faBarcode as falBarcode} from '@fortawesome/pro-light-svg-icons/faBarcode';
import {faBook as falBook} from '@fortawesome/pro-light-svg-icons/faBook';
import {faBooks as falBooks} from '@fortawesome/pro-light-svg-icons/faBooks';
import {faCactus as falCactus} from '@fortawesome/pro-light-svg-icons/faCactus';
import {faCalendar as fasCalendar} from '@fortawesome/pro-light-svg-icons/faCalendar';
import {faChalkboard as falChalkboard} from '@fortawesome/pro-light-svg-icons/faChalkboard';
import {faClock as falClock} from '@fortawesome/pro-light-svg-icons/faClock';
import {faChartLine as falChartLine} from '@fortawesome/pro-light-svg-icons/faChartLine';
import {faCircleUser as falCircleUser} from '@fortawesome/pro-light-svg-icons/faCircleUser';
import {faCheckCircle as falCheckCircle} from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import {faCircle as fasCircle} from '@fortawesome/pro-light-svg-icons/faCircle';
import {faCircleCheck as falCircleCheck} from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import {faCircleExclamation as falCircleExclamation} from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import {faCircleExclamationCheck as falCircleExclamationCheck} from '@fortawesome/pro-light-svg-icons/faCircleExclamationCheck';
import {faClock as fasClock} from '@fortawesome/pro-light-svg-icons/faClock';
import {faClone as fasClone} from '@fortawesome/pro-light-svg-icons/faClone';
import {faCloudSlash as falCloudSlash} from '@fortawesome/pro-light-svg-icons/faCloudSlash';
import {faComment as fasComment} from '@fortawesome/pro-light-svg-icons/faComment';
import {faCommentPen as falCommentPen} from '@fortawesome/pro-light-svg-icons/faCommentPen';
import {faCopy as falCopy} from '@fortawesome/pro-light-svg-icons/faCopy';
import {faDiamondExclamation as falDiamondExclamation} from '@fortawesome/pro-light-svg-icons/faDiamondExclamation';
import {faDumbbell as falDumbbell} from '@fortawesome/pro-light-svg-icons/faDumbbell';
import {faEdit as falEdit} from '@fortawesome/pro-light-svg-icons/faEdit';
import {faEllipsisH as falEllipsisH} from '@fortawesome/pro-light-svg-icons/faEllipsisH';
import {faEllipsisV as falEllipsisV} from '@fortawesome/pro-light-svg-icons/faEllipsisV';
import {faEnvelope as fasEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope';
import {faExclamationCircle as fasExclamationCircle} from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import {faExclamationTriangle as fasExclamationTriangle} from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import {faEyeSlash as falEyeSlash} from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import {faFaceDotted as falFaceDotted} from '@fortawesome/pro-light-svg-icons/faFaceDotted';
import {faFaceSurprise as falFaceSurprise} from '@fortawesome/pro-light-svg-icons/faFaceSurprise';
import {faFileAlt as falFileAlt} from '@fortawesome/pro-light-svg-icons/faFileAlt';
import {faFileContract as falFileContract} from '@fortawesome/pro-light-svg-icons/faFileContract';
import {faFileLines as falFileLines} from '@fortawesome/pro-light-svg-icons/faFileLines';
import {faFilePen as falFilePen} from '@fortawesome/pro-light-svg-icons/faFilePen';
import {faFileLock as falFileLock} from '@fortawesome/pro-light-svg-icons/faFileLock';
import {faFilterList as falFilterList} from '@fortawesome/pro-light-svg-icons/faFilterList';
import {faFolder as falFolder} from '@fortawesome/pro-light-svg-icons/faFolder';
import {faFolderOpen as falFolderOpen} from '@fortawesome/pro-light-svg-icons/faFolderOpen';
import {faFrown as falFrown} from '@fortawesome/pro-light-svg-icons/faFrown';
import {faGear as falGear} from '@fortawesome/pro-light-svg-icons/faGear';
import {faGraduationCap as falGraduationCap} from '@fortawesome/pro-light-svg-icons/faGraduationCap';
import {faHand as falHand} from '@fortawesome/pro-light-svg-icons/faHand';
import {faHome as falHome} from '@fortawesome/pro-light-svg-icons/faHome';
import {faIdCard as falIdCard} from '@fortawesome/pro-light-svg-icons/faIdCard';
import {faImage as falImage} from '@fortawesome/pro-light-svg-icons/faImage';
import {faInfoCircle as falInfoCircle} from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import {faKey as fasKey} from '@fortawesome/pro-light-svg-icons/faKey';
import {faKeyboard as fasKeyboard} from '@fortawesome/pro-solid-svg-icons/faKeyboard';
import {faVolumeLow as fasVolumeLow} from '@fortawesome/pro-solid-svg-icons/faVolumeLow';
import {faCirclePlay as fasCirclePlay} from '@fortawesome/pro-solid-svg-icons/faCirclePlay';
import {faCirclePause as fasCirclePause} from '@fortawesome/pro-solid-svg-icons/faCirclePause';
import {faAnglesLeft as fasAnglesLeft} from '@fortawesome/pro-solid-svg-icons/faAnglesLeft';
import {faAnglesRight as fasAnglesRight} from '@fortawesome/pro-solid-svg-icons/faAnglesRight';
import {faCaretUp as fasCaretUp} from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import {faCaretDown as fasCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faDeleteLeft as fasDeleteLeft} from '@fortawesome/pro-solid-svg-icons/faDeleteLeft';
import {faArrowTurnDownLeft as fasArrowTurnDownLeft} from '@fortawesome/pro-solid-svg-icons/faArrowTurnDownLeft';
import {faCircleQuestion as fasCircleQuestion} from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import {faArrowUp as fasArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faLanguage as falLanguage} from '@fortawesome/pro-light-svg-icons/faLanguage';
import {faLightbulbOn as falLightbulbOn} from '@fortawesome/pro-light-svg-icons/faLightbulbOn';
import {faLoader as falLoader} from '@fortawesome/pro-light-svg-icons/faLoader';
import {faLoader as farLoader} from '@fortawesome/pro-regular-svg-icons/faLoader';
import {faLoader as fasLoader} from '@fortawesome/pro-solid-svg-icons/faLoader';
import {faLink as falLink} from '@fortawesome/pro-light-svg-icons/faLink';
import {faListTree as falListTree} from '@fortawesome/pro-light-svg-icons/faListTree';
import {faMemoCircleInfo as falMemoCircleInfo} from '@fortawesome/pro-light-svg-icons/faMemoCircleInfo';
import {faMessageQuestion as falMessageQuestion} from '@fortawesome/pro-light-svg-icons/faMessageQuestion';
import {faMusic as falMusic} from '@fortawesome/pro-light-svg-icons/faMusic';
import {faOctagonExclamation} from '@fortawesome/pro-light-svg-icons/faOctagonExclamation';
import {faPencil as falPencil} from '@fortawesome/pro-light-svg-icons/faPencil';
import {faPenNib as falPenNib} from '@fortawesome/pro-light-svg-icons/faPenNib';
import {faPhotoFilmMusic as falPhotoFilmMusic} from '@fortawesome/pro-light-svg-icons/faPhotoFilmMusic';
import {faQuestionCircle as falQuestionCircle} from '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import {faRedo as fasRedo} from '@fortawesome/pro-light-svg-icons/faRedo';
import {faRedoAlt as fasRedoAlt} from '@fortawesome/pro-light-svg-icons/faRedoAlt';
import {faSchool as falSchool} from '@fortawesome/pro-light-svg-icons/faSchool';
import {faSearch as falSearch} from '@fortawesome/pro-light-svg-icons/faSearch';
import {faSparkles as falSparkles} from '@fortawesome/pro-light-svg-icons/faSparkles';
import {faStars as fasStars} from '@fortawesome/pro-light-svg-icons/faStars';
import {faStickyNote as fasStickyNote} from '@fortawesome/pro-light-svg-icons/faStickyNote';
import {faStopwatch as falStopwatch} from '@fortawesome/pro-light-svg-icons/faStopwatch';
import {faTags as falTags} from '@fortawesome/pro-light-svg-icons/faTags';
import {faThumbsUp as fasThumbsUp} from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import {faTrash as fasTrash} from '@fortawesome/pro-light-svg-icons/faTrash';
import {faTrashAlt as fasTrashAlt} from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import {faTrashCan as falTrashCan} from '@fortawesome/pro-light-svg-icons/faTrashCan';
import {faUpDown as farUpDown} from '@fortawesome/pro-light-svg-icons/faUpDown';
import {faUpload as falUpload} from '@fortawesome/pro-light-svg-icons/faUpload';
import {faUser as falUser} from '@fortawesome/pro-light-svg-icons/faUser';
import {faUserPlus as fasUserPlus} from '@fortawesome/pro-light-svg-icons/faUserPlus';
import {faUsers as falUsers} from '@fortawesome/pro-light-svg-icons/faUsers';
import {faWrench as falWrench} from '@fortawesome/pro-light-svg-icons/faWrench';
import {faXmark as fasXmark} from '@fortawesome/pro-light-svg-icons/faXmark';
import {faArrowLeft as farArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import {faCalendarLines as falCalendarLines} from '@fortawesome/pro-light-svg-icons/faCalendarLines';
import {faSun as falSun} from '@fortawesome/pro-light-svg-icons/faSun';
import {faMoon as falMoon} from '@fortawesome/pro-light-svg-icons/faMoon';
import {faFileAudio as falFileAudio} from '@fortawesome/pro-light-svg-icons/faFileAudio';

// Regular Icons
import {
  faArrowRotateLeft as farArrowRotateLeft,
  faCalendarLines as farCalendarLines,
  faMessageQuestion as farMessageQuestion,
  faSidebar as farSidebar
} from '@fortawesome/pro-regular-svg-icons';
import {faAlarmSnooze as farAlarmSnooze} from '@fortawesome/pro-regular-svg-icons/faAlarmSnooze';
import {faArchive as farArchive} from '@fortawesome/pro-regular-svg-icons/faArchive';
import {faArrowDown as farArrowDown} from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import {faArrowDownLeftAndArrowUpRightToCenter as farArrowDownLeftAndArrowUpRightToCenter} from '@fortawesome/pro-regular-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import {faArrowDownShortWide as farArrowDownShortWide} from '@fortawesome/pro-regular-svg-icons/faArrowDownShortWide';
import {faArrowRight as farArrowRight} from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import {faArrowRightArrowLeft as farArrowRightArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowRightArrowLeft';
import {faArrowsRotate as farArrowsRotate} from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import {faArrowsUpDown as farArrowUpDown} from '@fortawesome/pro-regular-svg-icons/faArrowsUpDown';
import {faArrowToTop as farArrowToTop} from '@fortawesome/pro-regular-svg-icons/faArrowToTop';
import {faArrowUp as farArrowUp} from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import {faArrowUpFromBracket as farArrowUpFromBracket} from '@fortawesome/pro-regular-svg-icons/faArrowUpFromBracket';
import {faArrowUpRight as farArrowUpRight} from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import {faArrowUpRightAndArrowDownLeftFromCenter as farArrowUpRightAndArrowDownLeftFromCenter} from '@fortawesome/pro-regular-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import {faArrowUpRightFromSquare as farArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import {faArrowLeftFromBracket as farArrowLeftFromBracket} from '@fortawesome/pro-regular-svg-icons/faArrowLeftFromBracket';
import {faBackpack as farBackpack} from '@fortawesome/pro-regular-svg-icons/faBackpack';
import {faBan as farBan} from '@fortawesome/pro-regular-svg-icons/faBan';
import {faBell as farBell} from '@fortawesome/pro-regular-svg-icons/faBell';
import {faBook as farBook} from '@fortawesome/pro-regular-svg-icons/faBook';
import {faBookOpen as farBookOpen} from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import {faBookOpenCover as farBookOpenCover} from '@fortawesome/pro-regular-svg-icons/faBookOpenCover';
import {faBookOpenLines as farBookOpenLines} from '@fortawesome/pro-regular-svg-icons/faBookOpenLines';
import {faCalculator as farCalculator} from '@fortawesome/pro-regular-svg-icons/faCalculator';
import {faCalculatorSimple as farCalculatorSimple} from '@fortawesome/pro-regular-svg-icons/faCalculatorSimple';
import {faBooks as farBooks} from '@fortawesome/pro-regular-svg-icons/faBooks';
import {faBoxArchive as farBoxArchive} from '@fortawesome/pro-regular-svg-icons/faBoxArchive';
import {faBracketCurly as farBracketCurly} from '@fortawesome/pro-regular-svg-icons/faBracketCurly';
import {faBullseyeArrow as farBullseyeArrow} from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow';
import {faCalendar as farCalendar} from '@fortawesome/pro-regular-svg-icons/faCalendar';
import {faCalendarAlt as farCalendarAlt} from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import {faCalendarDay as farCalendarDay} from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import {faCalendarXmark as farCalendarXmark} from '@fortawesome/pro-regular-svg-icons/faCalendarXmark';
import {faCaretRight as farCaretRight} from '@fortawesome/pro-regular-svg-icons/faCaretRight';
import {faChalkboard as farChalkboard} from '@fortawesome/pro-regular-svg-icons/faChalkboard';
import {faChalkboardUser as farChalkboardUser} from '@fortawesome/pro-regular-svg-icons/faChalkboardUser';
import {faChartLine as farChartLine} from '@fortawesome/pro-regular-svg-icons/faChartLine';
import {faChartPie as farChartPie} from '@fortawesome/pro-regular-svg-icons/faChartPie';
import {faChartLineUp as farChartLineUp} from '@fortawesome/pro-regular-svg-icons/faChartLineUp';
import {faChartSimple as farChartSimple} from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import {faCheck as farCheck} from '@fortawesome/pro-regular-svg-icons/faCheck';
import {faCheckCircle as farCheckCircle} from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import {faCheckDouble as farCheckDouble} from '@fortawesome/pro-regular-svg-icons/faCheckDouble';
import {faChevronDown as farChevronDown} from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import {faChevronLeft as farChevronLeft} from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import {faChevronRight as farChevronRight} from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import {faCircle as farCircle} from '@fortawesome/pro-regular-svg-icons/faCircle';
import {faCircleCheck as farCircleCheck} from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import {faCircleDashed as farCircleDashed} from '@fortawesome/pro-regular-svg-icons/faCircleDashed';
import {faCircleMinus as farCircleMinus} from '@fortawesome/pro-regular-svg-icons/faCircleMinus';
import {faCircleUser as farCircleUser} from '@fortawesome/pro-regular-svg-icons/faCircleUser';
import {faCirclePlus as farCirclePlus} from '@fortawesome/pro-regular-svg-icons/faCirclePlus';
import {faCircleXmark as farCircleXmark} from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import {faClock as farClock} from '@fortawesome/pro-regular-svg-icons/faClock';
import {faClockRotateLeft as farClockrotateLeft} from '@fortawesome/pro-regular-svg-icons/faClockRotateLeft';
import {faCloud as farCloud} from '@fortawesome/pro-regular-svg-icons/faCloud';
import {faCloudCheck as farCloudCheck} from '@fortawesome/pro-regular-svg-icons/faCloudCheck';
import {faCloudSlash as farCloudSlash} from '@fortawesome/pro-regular-svg-icons/faCloudSlash';
import {faCloudUpload as farCloudUpload} from '@fortawesome/pro-regular-svg-icons/faCloudUpload';
import {faCog as farCog} from '@fortawesome/pro-regular-svg-icons/faCog';
import {faComment as farComment} from '@fortawesome/pro-regular-svg-icons/faComment';
import {faComments as farComments} from '@fortawesome/pro-regular-svg-icons/faComments';
import {faConstruction as farConstruction} from '@fortawesome/pro-regular-svg-icons/faConstruction';
import {faCopy as farCopy} from '@fortawesome/pro-regular-svg-icons/faCopy';
import {faDesktop as farDesktop} from '@fortawesome/pro-regular-svg-icons/faDesktop';
import {faDiagramProject as farDiagramProject} from '@fortawesome/pro-regular-svg-icons/faDiagramProject';
import {faDice as farDice} from '@fortawesome/pro-regular-svg-icons/faDice';
import {faDownload as farDownload} from '@fortawesome/pro-regular-svg-icons/faDownload';
import {faMoon as farMoon} from '@fortawesome/pro-regular-svg-icons/faMoon';
import {faSun as farSun} from '@fortawesome/pro-regular-svg-icons/faSun';
import {faEllipsis as farEllipsis} from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import {faEnvelope as farEnvelope} from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import {faEnvelopeCircleUser as farEnvelopeCircleUser} from '@fortawesome/pro-regular-svg-icons/faEnvelopeCircleUser';
import {faBinary as farBinary} from '@fortawesome/pro-regular-svg-icons/faBinary';
import {faGears as farGears} from '@fortawesome/pro-regular-svg-icons/faGears';
import {faPersonChalkboard as farPersonChalkboard} from '@fortawesome/pro-regular-svg-icons/faPersonChalkboard';
import {faEnvelopeOpen as farEnvelopeOpen} from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpen';
import {faExclamationCircle as farExclamationCircle} from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import {faExclamationTriangle as farExclamationTriangle} from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import {faExpandAlt} from '@fortawesome/pro-regular-svg-icons/faExpandAlt';
import {faEye as farEye} from '@fortawesome/pro-regular-svg-icons/faEye';
import {faEyeSlash as farEyeSlash} from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import {faFileAlt as farFileAlt} from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import {faFileContract as farFileContract} from '@fortawesome/pro-regular-svg-icons/faFileContract';
import {faFileExport as farFileExport} from '@fortawesome/pro-regular-svg-icons/faFileExport';
import {faFileLines as farFileLines} from '@fortawesome/pro-regular-svg-icons/faFileLines';
import {faFilePlus as farFilePlus} from '@fortawesome/pro-regular-svg-icons/faFilePlus';
import {faFiles as farFiles} from '@fortawesome/pro-regular-svg-icons/faFiles';
import {faFilter as farFilter} from '@fortawesome/pro-regular-svg-icons/faFilter';
import {faForwardFast as farForwardFast} from '@fortawesome/pro-regular-svg-icons/faForwardFast';
import {faFilterList as farFilterList} from '@fortawesome/pro-regular-svg-icons/faFilterList';
import {faFlagCheckered as farFlagCheckered} from '@fortawesome/pro-regular-svg-icons/faFlagCheckered';
import {faFolder as farFolder} from '@fortawesome/pro-regular-svg-icons/faFolder';
import {faFunction as farFunction} from '@fortawesome/pro-regular-svg-icons/faFunction';
import {faFolderOpen as farFolderOpen} from '@fortawesome/pro-regular-svg-icons/faFolderOpen';
import {faFolderPlus as farFolderPlus} from '@fortawesome/pro-regular-svg-icons/faFolderPlus';
import {faFolders as farFolders} from '@fortawesome/pro-regular-svg-icons/faFolders';
import {faFrown as farFrown} from '@fortawesome/pro-regular-svg-icons/faFrown';
import {faFrownOpen as farFrownOpen} from '@fortawesome/pro-regular-svg-icons/faFrownOpen';
import {faGraduationCap as farGraduationCap} from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import {faHandPointer as farHandPointer} from '@fortawesome/pro-regular-svg-icons/faHandPointer';
import {faHandPointLeft as farHandPointLeft} from '@fortawesome/pro-regular-svg-icons/faHandPointLeft';
import {faHeartCrack as farHeartCrack} from '@fortawesome/pro-regular-svg-icons/faHeartCrack';
import {faHexagonExclamation as farHexagonExclamation} from '@fortawesome/pro-regular-svg-icons/faHexagonExclamation';
import {faHighlighter as farHighlighter} from '@fortawesome/pro-regular-svg-icons/faHighlighter';
import {faHome as farHome} from '@fortawesome/pro-regular-svg-icons/faHome';
import {faICursor as farICursor} from '@fortawesome/pro-regular-svg-icons/faICursor';
import {faImage as farImage} from '@fortawesome/pro-regular-svg-icons/faImage';
import {faInfoCircle as farInfoCircle} from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import {faSlash as farSlash} from '@fortawesome/pro-regular-svg-icons/faSlash';
import {faKey as farKey} from '@fortawesome/pro-regular-svg-icons/faKey';
import {faLaugh as farLaugh} from '@fortawesome/pro-regular-svg-icons/faLaugh';
import {faLifeRing as farLifeRing} from '@fortawesome/pro-regular-svg-icons/faLifeRing';
import {faLightbulbOn as farLightbulbOn} from '@fortawesome/pro-regular-svg-icons/faLightbulbOn';
import {faLink as farLink} from '@fortawesome/pro-regular-svg-icons/faLink';
import {faList as farList} from '@fortawesome/pro-regular-svg-icons/faList';
import {faLock as farLock} from '@fortawesome/pro-regular-svg-icons/faLock';
import {faLockOpen as farLockOpen} from '@fortawesome/pro-regular-svg-icons/faLockOpen';
import {faMagnifyingGlass as farMagnifyingGlass} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import {faCommand as farCommand} from '@fortawesome/pro-regular-svg-icons/faCommand';
import {faDownLeftAndUpRightToCenter as farDownLeftAndUpRightToCenter} from '@fortawesome/pro-regular-svg-icons/faDownLeftAndUpRightToCenter';
import {faKeyboard as farKeyboard} from '@fortawesome/pro-regular-svg-icons/faKeyboard';
import {faMagnifyingGlassArrowsRotate as farMagnifyingGlassArrowsRotate} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassArrowsRotate';
import {faMagnifyingGlassMinus as farMagnifyingGlassMinus} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassMinus';
import {faMagnifyingGlassPlus as farMagnifyingGlassPlus} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus';
import {faUndo as farUndo} from '@fortawesome/pro-regular-svg-icons/faUndo';
import {faMemoCircleInfo as farMemoCircleInfo} from '@fortawesome/pro-regular-svg-icons/faMemoCircleInfo';
import {faCommentDot as farCommentDot} from '@fortawesome/pro-regular-svg-icons/faCommentDot';
import {faMessageLines as farMessageLines} from '@fortawesome/pro-regular-svg-icons/faMessageLines';
import {faMessagePen as farMessagePen} from '@fortawesome/pro-regular-svg-icons/faMessagePen';
import {faMessagePlus as farMessagePlus} from '@fortawesome/pro-regular-svg-icons/faMessagePlus';
import {faMinus as farMinus} from '@fortawesome/pro-regular-svg-icons/faMinus';
import {faMinusCircle as farMinusCircle} from '@fortawesome/pro-regular-svg-icons/faMinusCircle';
import {faMobileSlash as farMobileSlash} from '@fortawesome/pro-regular-svg-icons/faMobileSlash';
import {faMusic as farMusic} from '@fortawesome/pro-regular-svg-icons/faMusic';
import {faObjectsColumn as farObjectsColumn} from '@fortawesome/pro-regular-svg-icons/faObjectsColumn';
import {faPaperPlane as farPaperPlane} from '@fortawesome/pro-regular-svg-icons/faPaperPlane';
import {faPartyHorn as farPartyHorn} from '@fortawesome/pro-regular-svg-icons/faPartyHorn';
import {faPencil as farPencil} from '@fortawesome/pro-regular-svg-icons/faPencil';
import {faPencilSlash as farPencilSlash} from '@fortawesome/pro-regular-svg-icons/faPencilSlash';
import {faPenToSquare as farPenToSquare} from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import {faPlus as farPlus} from '@fortawesome/pro-regular-svg-icons/faPlus';
import {faQuestion as farQuestion} from '@fortawesome/pro-regular-svg-icons/faQuestion';
import {faQuestionCircle as farQuestionCircle} from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import {faRedo as farRedo} from '@fortawesome/pro-regular-svg-icons/faRedo';
import {faRotateRight as farRotateRight} from '@fortawesome/pro-regular-svg-icons/faRotateRight';
import {faSchool as farSchool} from '@fortawesome/pro-regular-svg-icons/faSchool';
import {faSchoolCircleExclamation as farSchoolCircleExclamation} from '@fortawesome/pro-regular-svg-icons/faSchoolCircleExclamation';
import {faSearchMinus as farSearchMinus} from '@fortawesome/pro-regular-svg-icons/faSearchMinus';
import {faSortAmountUp as farSortAmountUp} from '@fortawesome/pro-regular-svg-icons/faSortAmountUp';
import {faSparkles as farSparkles} from '@fortawesome/pro-regular-svg-icons/faSparkles';
import {faSpinner as farSpinner} from '@fortawesome/pro-regular-svg-icons/faSpinner';
import {faStickyNote as farStickyNote} from '@fortawesome/pro-regular-svg-icons/faStickyNote';
import {faStopwatch as farStopwatch} from '@fortawesome/pro-regular-svg-icons/faStopwatch';
import {faSync as farSync} from '@fortawesome/pro-regular-svg-icons/faSync';
import {faTable as farTable} from '@fortawesome/pro-regular-svg-icons/faTable';
import {faTableColumns as farTableColumns} from '@fortawesome/pro-regular-svg-icons/faTableColumns';
import {faText as farText} from '@fortawesome/pro-regular-svg-icons/faText';
import {faThumbsUp as farThumbsUp} from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import {faTimes as farTimes} from '@fortawesome/pro-regular-svg-icons/faTimes';
import {faTools as farTools} from '@fortawesome/pro-regular-svg-icons/faTools';
import {faTrash as farTrash} from '@fortawesome/pro-regular-svg-icons/faTrash';
import {faTrashAlt as farTrashAlt} from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import {faTrashCanSlash as farTrashCanSlash} from '@fortawesome/pro-regular-svg-icons/faTrashCanSlash';
import {faUnderline as farUnderline} from '@fortawesome/pro-regular-svg-icons/faUnderline';
import {faUser as farUser} from '@fortawesome/pro-regular-svg-icons/faUser';
import {faUserPlus as farUserPlus} from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import {faUsers as farUsers} from '@fortawesome/pro-regular-svg-icons/faUsers';
import {faVolume as farVolume} from '@fortawesome/pro-regular-svg-icons/faVolume';
import {faXmark as farXmark} from '@fortawesome/pro-regular-svg-icons/faXmark';
import {faListCheck as farListCheck} from '@fortawesome/pro-regular-svg-icons/faListCheck';
import {faArrowsToLine as farArrowsToLine} from '@fortawesome/pro-regular-svg-icons/faArrowsToLine';
import {faArrowsFromLine as farArrowsFromLine} from '@fortawesome/pro-regular-svg-icons/faArrowsFromLine';
import {faTextSize as farTextSize} from '@fortawesome/pro-regular-svg-icons/faTextSize';
import {faFont as farFont} from '@fortawesome/pro-regular-svg-icons/faFont';
import {faFileLock as farFileLock} from '@fortawesome/pro-regular-svg-icons/faFileLock';
import {faShield as farShield} from '@fortawesome/pro-regular-svg-icons/faShield';
import {faWaveSine as farWaveSine} from '@fortawesome/pro-regular-svg-icons/faWaveSine';

// Solid Icons
import {faCircleXmark, faLanguage, faScreenUsers} from '@fortawesome/pro-solid-svg-icons';
import {faAlignRight} from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import {faArchive} from '@fortawesome/pro-solid-svg-icons/faArchive';
import {faArrowDown} from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import {faArrowDownWideShort} from '@fortawesome/pro-solid-svg-icons/faArrowDownWideShort';
import {faArrowLeft} from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import {faArrowLeftToLine} from '@fortawesome/pro-solid-svg-icons/faArrowLeftToLine';
import {faArrowRight} from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import {faArrowRightToLine} from '@fortawesome/pro-solid-svg-icons/faArrowRightToLine';
import {faArrowRotateLeft} from '@fortawesome/pro-solid-svg-icons/faArrowRotateLeft';
import {faArrowsAltH} from '@fortawesome/pro-solid-svg-icons/faArrowsAltH';
import {faArrowsV} from '@fortawesome/pro-solid-svg-icons/faArrowsV';
import {faArrowToLeft} from '@fortawesome/pro-solid-svg-icons/faArrowToLeft';
import {faArrowToTop} from '@fortawesome/pro-solid-svg-icons/faArrowToTop';
import {faArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faArrowUpRightFromSquare} from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import {faAsterisk} from '@fortawesome/pro-solid-svg-icons/faAsterisk';
import {faBackpack} from '@fortawesome/pro-solid-svg-icons/faBackpack';
import {faBackwardStep} from '@fortawesome/pro-solid-svg-icons/faBackwardStep';
import {faBan} from '@fortawesome/pro-solid-svg-icons/faBan';
import {faBarcodeRead} from '@fortawesome/pro-solid-svg-icons/faBarcodeRead';
import {faBars} from '@fortawesome/pro-solid-svg-icons/faBars';
import {faBarsFilter} from '@fortawesome/pro-solid-svg-icons/faBarsFilter';
import {faBellRing} from '@fortawesome/pro-solid-svg-icons/faBellRing';
import {faBellSlash} from '@fortawesome/pro-solid-svg-icons/faBellSlash';
import {faBold} from '@fortawesome/pro-solid-svg-icons/faBold';
import {faBookmark} from '@fortawesome/pro-solid-svg-icons/faBookmark';
import {faBooks} from '@fortawesome/pro-solid-svg-icons/faBooks';
import {faCalendar} from '@fortawesome/pro-solid-svg-icons/faCalendar';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faCaretLeft} from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import {faCaretUp} from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import {faCertificate} from '@fortawesome/pro-solid-svg-icons/faCertificate';
import {faChartScatter} from '@fortawesome/pro-solid-svg-icons/faChartScatter';
import {faCheck} from '@fortawesome/pro-solid-svg-icons/faCheck';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faCheckDouble} from '@fortawesome/pro-solid-svg-icons/faCheckDouble';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import {faChevronUp} from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import {faCircle} from '@fortawesome/pro-solid-svg-icons/faCircle';
import {faCircle1} from '@fortawesome/pro-solid-svg-icons/faCircle1';
import {faCircle2} from '@fortawesome/pro-solid-svg-icons/faCircle2';
import {faCircle3} from '@fortawesome/pro-solid-svg-icons/faCircle3';
import {faCircleX} from '@fortawesome/pro-solid-svg-icons/faCircleX';
import {faClipboard} from '@fortawesome/pro-solid-svg-icons/faClipboard';
import {faClock} from '@fortawesome/pro-solid-svg-icons/faClock';
import {faClone} from '@fortawesome/pro-solid-svg-icons/faClone';
import {faCloud} from '@fortawesome/pro-solid-svg-icons/faCloud';
import {faCloudUpload} from '@fortawesome/pro-solid-svg-icons/faCloudUpload';
import {faCode} from '@fortawesome/pro-solid-svg-icons/faCode';
import {faCog} from '@fortawesome/pro-solid-svg-icons/faCog';
import {faComment} from '@fortawesome/pro-solid-svg-icons/faComment';
import {faCopy} from '@fortawesome/pro-solid-svg-icons/faCopy';
import {faCreditCardBlank} from '@fortawesome/pro-solid-svg-icons/faCreditCardBlank';
import {faDownLeftAndUpRightToCenter} from '@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter';
import {faDownload} from '@fortawesome/pro-solid-svg-icons/faDownload';
import {faEllipsisH} from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import {faEllipsisV} from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import {faExchange} from '@fortawesome/pro-solid-svg-icons/faExchange';
import {faExclamation} from '@fortawesome/pro-solid-svg-icons/faExclamation';
import {faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import {faExpandArrowsAlt} from '@fortawesome/pro-solid-svg-icons/faExpandArrowsAlt';
import {faExternalLinkAlt} from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';
import {faEye} from '@fortawesome/pro-solid-svg-icons/faEye';
import {faEyeSlash} from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import {faFax} from '@fortawesome/pro-solid-svg-icons/faFax';
import {faFileAlt} from '@fortawesome/pro-solid-svg-icons/faFileAlt';
import {faFileLock} from '@fortawesome/pro-solid-svg-icons/faFileLock';
import {faFileLines} from '@fortawesome/pro-solid-svg-icons/faFileLines';
import {faFilePlus} from '@fortawesome/pro-solid-svg-icons/faFilePlus';
import {faFilter} from '@fortawesome/pro-solid-svg-icons/faFilter';
import {faFolderOpen} from '@fortawesome/pro-solid-svg-icons/faFolderOpen';
import {faFolderPlus} from '@fortawesome/pro-solid-svg-icons/faFolderPlus';
import {faFrownOpen} from '@fortawesome/pro-solid-svg-icons/faFrownOpen';
import {faGem} from '@fortawesome/pro-solid-svg-icons/faGem';
import {faGreaterThan} from '@fortawesome/pro-solid-svg-icons/faGreaterThan';
import {faH1} from '@fortawesome/pro-solid-svg-icons/faH1';
import {faH2} from '@fortawesome/pro-solid-svg-icons/faH2';
import {faHand} from '@fortawesome/pro-solid-svg-icons/faHand';
import {faHandPointer} from '@fortawesome/pro-solid-svg-icons/faHandPointer';
import {faHeading} from '@fortawesome/pro-solid-svg-icons/faHeading';
import {faHeadset} from '@fortawesome/pro-solid-svg-icons/faHeadset';
import {faHistory} from '@fortawesome/pro-solid-svg-icons/faHistory';
import {faHorizontalRule} from '@fortawesome/pro-solid-svg-icons/faHorizontalRule';
import {faICursor} from '@fortawesome/pro-solid-svg-icons/faICursor';
import {faImage} from '@fortawesome/pro-solid-svg-icons/faImage';
import {faIndent} from '@fortawesome/pro-solid-svg-icons/faIndent';
import {faInfo} from '@fortawesome/pro-solid-svg-icons/faInfo';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import {faCircleCheck} from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import {faCircleExclamation} from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import {faItalic} from '@fortawesome/pro-solid-svg-icons/faItalic';
import {faKey} from '@fortawesome/pro-solid-svg-icons/faKey';
import {faLevelUpAlt} from '@fortawesome/pro-solid-svg-icons/faLevelUpAlt';
import {faLightbulbOn} from '@fortawesome/pro-solid-svg-icons/faLightbulbOn';
import {faLink} from '@fortawesome/pro-solid-svg-icons/faLink';
import {faListOl} from '@fortawesome/pro-solid-svg-icons/faListOl';
import {faListUl} from '@fortawesome/pro-solid-svg-icons/faListUl';
import {faLock} from '@fortawesome/pro-solid-svg-icons/faLock';
import {faLockOpen} from '@fortawesome/pro-solid-svg-icons/faLockOpen';
import {faUnlock} from '@fortawesome/pro-solid-svg-icons/faUnlock';
import {faLongArrowAltRight} from '@fortawesome/pro-solid-svg-icons/faLongArrowAltRight';
import {faMagnifyingGlass} from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import {faFunction} from '@fortawesome/pro-solid-svg-icons/faFunction';
import {faMagnifyingGlassPlus} from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassPlus';
import {faMinus} from '@fortawesome/pro-solid-svg-icons/faMinus';
import {faOutdent} from '@fortawesome/pro-solid-svg-icons/faOutdent';
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import {faPause} from '@fortawesome/pro-solid-svg-icons/faPause';
import {faPencil} from '@fortawesome/pro-solid-svg-icons/faPencil';
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons/faPencilAlt';
import {faPersonChalkboard} from '@fortawesome/pro-solid-svg-icons/faPersonChalkboard';
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone';
import {faPlay} from '@fortawesome/pro-solid-svg-icons/faPlay';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import {faQuestion} from '@fortawesome/pro-solid-svg-icons/faQuestion';
import {faQuestionCircle} from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import {faRectanglePro} from '@fortawesome/pro-solid-svg-icons/faRectanglePro';
import {faRedo} from '@fortawesome/pro-solid-svg-icons/faRedo';
import {faRedoAlt} from '@fortawesome/pro-solid-svg-icons/faRedoAlt';
import {faRepeat} from '@fortawesome/pro-solid-svg-icons/faRepeat';
import {faRetweet} from '@fortawesome/pro-solid-svg-icons/faRetweet';
import {faRocket} from '@fortawesome/pro-solid-svg-icons/faRocket';
import {faRotateLeft} from '@fortawesome/pro-solid-svg-icons/faRotateLeft';
import {faRotateRight} from '@fortawesome/pro-solid-svg-icons/faRotateRight';
import {faSchool} from '@fortawesome/pro-solid-svg-icons/faSchool';
import {faSearch} from '@fortawesome/pro-solid-svg-icons/faSearch';
import {faShare} from '@fortawesome/pro-solid-svg-icons/faShare';
import {faShield} from '@fortawesome/pro-solid-svg-icons/faShield';
import {faShieldHalved} from '@fortawesome/pro-solid-svg-icons/faShieldHalved';
import {faSliders} from '@fortawesome/pro-solid-svg-icons/faSliders';
import {faSlidersH} from '@fortawesome/pro-solid-svg-icons/faSlidersH';
import {faSortAmountDown} from '@fortawesome/pro-solid-svg-icons/faSortAmountDown';
import {faSortAmountUp} from '@fortawesome/pro-solid-svg-icons/faSortAmountUp';
import {faSparkles} from '@fortawesome/pro-solid-svg-icons/faSparkles';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons/faSpinner';
import {faSpinnerThird} from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import {faStars} from '@fortawesome/pro-solid-svg-icons/faStars';
import {faStickyNote} from '@fortawesome/pro-solid-svg-icons/faStickyNote';
import {faSubscript} from '@fortawesome/pro-solid-svg-icons/faSubscript';
import {faSuperscript} from '@fortawesome/pro-solid-svg-icons/faSuperscript';
import {faSync} from '@fortawesome/pro-solid-svg-icons/faSync';
import {faTable} from '@fortawesome/pro-solid-svg-icons/faTable';
import {faTag} from '@fortawesome/pro-solid-svg-icons/faTag';
import {faTextSize} from '@fortawesome/pro-solid-svg-icons/faTextSize';
import {faThumbsUp} from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes';
import {faTrash} from '@fortawesome/pro-solid-svg-icons/faTrash';
import {faUmbrellaBeach} from '@fortawesome/pro-solid-svg-icons/faUmbrellaBeach';
import {faUnderline} from '@fortawesome/pro-solid-svg-icons/faUnderline';
import {faUndo} from '@fortawesome/pro-solid-svg-icons/faUndo';
import {faUnion} from '@fortawesome/pro-solid-svg-icons/faUnion';
import {faUnlink} from '@fortawesome/pro-solid-svg-icons/faUnlink';
import {faUpDown} from '@fortawesome/pro-solid-svg-icons/faUpDown';
import {faUpRightAndDownLeftFromCenter} from '@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter';
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser';
import {faUserPlus} from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import {faVectorSquare} from '@fortawesome/pro-solid-svg-icons/faVectorSquare';
import {faVideo} from '@fortawesome/pro-solid-svg-icons/faVideo';
import {faVolume} from '@fortawesome/pro-solid-svg-icons/faVolume';
import {faVolumeUp} from '@fortawesome/pro-solid-svg-icons/faVolumeUp';
import {faXmark} from '@fortawesome/pro-solid-svg-icons/faXmark';
import {faHouse} from '@fortawesome/pro-solid-svg-icons/faHouse';
import {faCircleArrowRight} from '@fortawesome/pro-solid-svg-icons/faCircleArrowRight';
import {faSort} from '@fortawesome/pro-solid-svg-icons/faSort';
import {faPaste} from '@fortawesome/pro-solid-svg-icons/faPaste';
import {faArrowDownZA} from '@fortawesome/pro-solid-svg-icons/faArrowDownZA';
import {faArrowDownAZ} from '@fortawesome/pro-solid-svg-icons/faArrowDownAZ';
import {faArrowDown19} from '@fortawesome/pro-solid-svg-icons/faArrowDown19';
import {faArrowDown91} from '@fortawesome/pro-solid-svg-icons/faArrowDown91';
import {faArrowDownShortWide} from '@fortawesome/pro-solid-svg-icons/faArrowDownShortWide';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import {faAngleDown} from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import {faArrowTurnDownRight as farArrowTurnDownRight} from '@fortawesome/pro-regular-svg-icons';
import {faChevronUp as farChevronUp} from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import {faExpand as farExpand} from '@fortawesome/pro-regular-svg-icons/faExpand';
import {faSidebarFlip as farSidebarFlip} from '@fortawesome/pro-regular-svg-icons/faSidebarFlip';
import {faWindowRestore as farWindowRestore} from '@fortawesome/pro-regular-svg-icons/faWindowRestore';
import {faGripDotsVertical, faGripVertical} from '@fortawesome/pro-solid-svg-icons';
import {faPhotoFilmMusic} from '@fortawesome/pro-solid-svg-icons/faPhotoFilmMusic';

// Custom Kit Icons (FontAwesome Kit — `fak` prefix, uploaded via the kit at
// fontawesome.com/kits/50b6f67b64).
//
// Namespace-import the custom-icons subpath and register every icon it exports.
// This pulls in ONLY the kit's custom (uploaded) icons — not the kit's `all`
// export, which bundles the entire FA catalog (~77k icons). Any icon uploaded to
// the kit later is picked up automatically once the kit package is updated.
import * as kitCustomIcons from '@awesome.me/kit-50b6f67b64/icons/kit/custom';

/**
 * This file acts as a manifest for all supported FontAwesome 5 icons.
 * If you don't see the icon you need listed, add it!
 *
 * @see https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 */

const brandIcons = [
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faChrome,
  faFacebookF,
  faGoogle,
  faInstagram,
  faTwitter
];

const solidIcons = [
  fasLoader,
  faAlignRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowLeftToLine,
  faArrowRightToLine,
  faArrowToLeft,
  faArrowRight,
  faArrowsAltH,
  faArrowsV,
  faArrowToTop,
  faArrowUp,
  faArrowUpRightFromSquare,
  faAsterisk,
  faBackpack,
  faBackwardStep,
  faBan,
  faBarsFilter,
  faBarcodeRead,
  faBars,
  faBold,
  faBookmark,
  faBooks,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCertificate,
  faChartScatter,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircleX,
  faClipboard,
  faClock,
  faClone,
  faCloud,
  faCloudUpload,
  faCode,
  faCog,
  faComment,
  faCopy,
  faCreditCardBlank,
  faDownload,
  faDownLeftAndUpRightToCenter,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faExchange,
  faExclamation,
  faExclamationTriangle,
  faExpandArrowsAlt,
  faExpandAlt,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFax,
  faFileAlt,
  faFileLock,
  faFileLines,
  faFilePlus,
  faFilter,
  faFolderPlus,
  faFrownOpen,
  faGem,
  faGreaterThan,
  faHand,
  faHandPointer,
  faFolderOpen,
  faH1,
  faH2,
  faHeading,
  faHeadset,
  faHistory,
  faHorizontalRule,
  faICursor,
  faImage,
  faIndent,
  faInfo,
  faInfoCircle,
  faCircleCheck,
  faCircleExclamation,
  faItalic,
  faKey,
  faLanguage,
  faLevelUpAlt,
  faLink,
  faLightbulbOn,
  faListOl,
  faListUl,
  faLock,
  faLongArrowAltRight,
  faMagnifyingGlass,
  faFunction,
  faMagnifyingGlassPlus,
  faMinus,
  faOutdent,
  faPaperPlane,
  faPause,
  faPencil,
  faPencilAlt,
  faPersonChalkboard,
  faPhone,
  faPlus,
  faPlay,
  faQuestion,
  faQuestionCircle,
  faRedo,
  faRedoAlt,
  faRepeat,
  faRetweet,
  faRocket,
  faRotateLeft,
  faRotateRight,
  faSchool,
  faScreenUsers,
  faSearch,
  faShare,
  faShield,
  faShieldHalved,
  faSliders,
  faSlidersH,
  faSortAmountDown,
  faSortAmountUp,
  faStickyNote,
  faSparkles,
  faSpinner,
  faSpinnerThird,
  faStars,
  faSubscript,
  faSuperscript,
  faSync,
  faTable,
  faTag,
  faTextSize,
  faThumbsUp,
  faTimes,
  faTrash,
  faUmbrellaBeach,
  faUnderline,
  faUndo,
  faUnlink,
  faUnion,
  faUpDown,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserPlus,
  faVectorSquare,
  faVideo,
  faVolume,
  faVolumeUp,
  faXmark,
  faArrowRotateLeft,
  faArrowDownWideShort,
  faRectanglePro,
  faLockOpen,
  faUnlock,
  faCircleXmark,
  faBellSlash,
  faBellRing,
  faGripDotsVertical,
  faGripVertical,
  faPhotoFilmMusic,
  faHouse,
  faCircleArrowRight,
  faSort,
  faPaste,
  faArrowDownZA,
  faArrowDownAZ,
  faArrowDown19,
  faArrowDown91,
  faArrowDownShortWide,
  faAngleRight,
  faAngleDown
];

const regularIcons = [
  farBinary,
  farGears,
  farPersonChalkboard,
  farLoader,
  farArchive,
  farArrowDown,
  farArrowRight,
  farArrowLeft,
  farArrowToTop,
  farArrowUp,
  farArrowLeftFromBracket,
  farArrowUpFromBracket,
  farArrowUpDown,
  farArrowUpRightFromSquare,
  farArrowUpRight,
  farArrowUpRightAndArrowDownLeftFromCenter,
  farArrowDownLeftAndArrowUpRightToCenter,
  farArrowDownShortWide,
  farArrowsRotate,
  farBackpack,
  farBan,
  farBell,
  farBook,
  farBullseyeArrow,
  farBookOpen,
  farBookOpenCover,
  farBookOpenLines,
  farBooks,
  farBracketCurly,
  farCalculator,
  farCalculatorSimple,
  farChartLine,
  farChartPie,
  farCalendarAlt,
  farCaretRight,
  farCheck,
  farCheckCircle,
  farCheckDouble,
  farChevronUp,
  farChevronDown,
  farChevronRight,
  farChevronLeft,
  farCircle,
  farCircleCheck,
  farCircleMinus,
  farCirclePlus,
  farCircleUser,
  farCircleXmark,
  farClock,
  farClockrotateLeft,
  farCloud,
  farCloudCheck,
  farCloudUpload,
  farCog,
  farComment,
  farConstruction,
  farDownload,
  farCopy,
  farEllipsis,
  farEnvelope,
  farEnvelopeCircleUser,
  farEnvelopeOpen,
  farExclamationCircle,
  farExclamationTriangle,
  farEye,
  farEyeSlash,
  farFileAlt,
  farFileContract,
  farFileExport,
  farFileLines,
  farFiles,
  farFileLock,
  farFilePlus,
  farFilter,
  farFolder,
  farFolders,
  farFolderOpen,
  farFolderPlus,
  farFrownOpen,
  farFrown,
  farFunction,
  farGraduationCap,
  farHandPointLeft,
  farHeartCrack,
  farHexagonExclamation,
  farHighlighter,
  farHome,
  farICursor,
  farInfoCircle,
  farSlash,
  farKey,
  farLaugh,
  farLightbulbOn,
  farLink,
  farList,
  farMagnifyingGlass,
  farCommand,
  farDownLeftAndUpRightToCenter,
  farKeyboard,
  farMagnifyingGlassArrowsRotate,
  farMagnifyingGlassMinus,
  farMagnifyingGlassPlus,
  farUndo,
  farMessageLines,
  farCommentDot,
  farMobileSlash,
  farMusic,
  farObjectsColumn,
  farPaperPlane,
  farPartyHorn,
  farPencil,
  farQuestion,
  farQuestionCircle,
  farRedo,
  farRotateRight,
  farSchool,
  farSchoolCircleExclamation,
  farSortAmountUp,
  farSparkles,
  farStickyNote,
  farSync,
  farTable,
  farText,
  farThumbsUp,
  farTools,
  farTrash,
  farTrashCanSlash,
  farTrashAlt,
  farUnderline,
  farUpDown,
  farUserPlus,
  farUsers,
  farVolume,
  farWaveSine,
  farXmark,
  farImage,
  farPlus,
  farMinus,
  farMinusCircle,
  farForwardFast,
  farSearchMinus,
  farChalkboardUser,
  farTableColumns,
  farMessagePen,
  farMessagePlus,
  farCalendarDay,
  farCalendarXmark,
  farAlarmSnooze,
  farDesktop,
  farDiagramProject,
  farDice,
  farMoon,
  farSun,
  farStopwatch,
  farLock,
  farLockOpen,
  farUser,
  farSpinner,
  farCircleDashed,
  farFlagCheckered,
  farPenToSquare,
  farBoxArchive,
  farPencilSlash,
  farArrowRightArrowLeft,
  farChartLineUp,
  farChartSimple,
  farMessageQuestion,
  farExpand,
  farSidebar,
  farSidebarFlip,
  farWindowRestore,
  farCloudSlash,
  farMemoCircleInfo,
  farCalendar,
  farLifeRing,
  farComments,
  farArrowRotateLeft,
  farCalendarLines,
  farArrowTurnDownRight,
  farFilterList,
  farListCheck,
  farArrowsToLine,
  farArrowsFromLine,
  farTextSize,
  farFont,
  farShield
];

const lightIcons = [
  falCircleUser,
  falLightbulbOn,
  falLoader,
  falArrowLeft,
  falArrowRight,
  falAlignLeft,
  falArrowsRotate,
  faOctagonExclamation,
  farHandPointer,
  farLink,
  farQuestion,
  farTimes,
  farTrash,
  fasCalendar,
  farChalkboard,
  fasCircle,
  falCircleExclamation,
  falCircleExclamationCheck,
  falCircleCheck,
  fasClock,
  fasClone,
  fasComment,
  falEllipsisH,
  falEllipsisV,
  fasEnvelope,
  fasExclamationCircle,
  fasExclamationTriangle,
  falFaceSurprise,
  falFileAlt,
  falFilePen,
  falFolderOpen,
  falHand,
  falHome,
  falInfoCircle,
  fasKey,
  fasKeyboard,
  fasVolumeLow,
  fasCirclePlay,
  fasCirclePause,
  fasAnglesLeft,
  fasAnglesRight,
  fasCaretUp,
  fasCaretDown,
  fasDeleteLeft,
  fasArrowTurnDownLeft,
  fasCircleQuestion,
  fasArrowUp,
  falMessageQuestion,
  falQuestionCircle,
  falUser,
  falWrench,
  falPenNib,
  falCommentPen,
  falBook,
  falArrowRightFromBracket,
  falChartLine,
  fasRedo,
  fasRedoAlt,
  fasStickyNote,
  falArchive,
  falFrown,
  falSchool,
  falSearch,
  fasStars,
  fasThumbsUp,
  fasTrash,
  fasTrashAlt,
  falUpload,
  fasUserPlus,
  fasXmark,
  falCactus,
  falCheckCircle,
  falUsers,
  falPencil,
  falFileLines,
  falFileContract,
  falFileLock,
  falArrowUpFromBracket,
  falTrashCan,
  falIdCard,
  falDumbbell,
  falDiamondExclamation,
  falEdit,
  falBooks,
  falTags,
  falListTree,
  falLanguage,
  falChalkboard,
  falClock,
  falFolder,
  falPhotoFilmMusic,
  falMusic,
  falImage,
  falCloudSlash,
  falArrowsRotateReverse,
  falLink,
  falFaceDotted,
  falBadgeCheck,
  falCopy,
  falMemoCircleInfo,
  falGear,
  falEyeSlash,
  falGraduationCap,
  falFilterList,
  falCalendarLines,
  falSun,
  falMoon,
  falSparkles,
  falFileAudio,
  falBarcode,
  falBan,
  falStopwatch
];

const kitIcons = Object.values(kitCustomIcons);

/**
 * We manually add the CSS to the page in our SSR
 *
 * @see src/server/Html.react.js
 */
config.autoAddCss = false;

library.add(...brandIcons, ...solidIcons, ...regularIcons, ...lightIcons, ...kitIcons);
